import React, {Component} from "react";
import {LOCAL} from "../../../constants/local";

class TakemoneyItem extends Component {
	render() {
		const {bank, changeBank} = this.props;
		const img = require(`./../../../../assets/images/${bank.img}`);

		return (
			<div className="table__row data">
				<div className="table__column payment-type">
					<img src={img} alt=""/>
					<span>{bank.name}</span>
				</div>
				<div className="table__column comission">0%</div>
				<div className="table__column in-processing">1-2 дня</div>
				<div className="table__column min-sum">10 {LOCAL.currency}</div>
				<div className="table__column actions">
					<div className="buttons">
						<button className="buttons__show" onClick={changeBank}>
							Заказать выплату
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default TakemoneyItem;


// WEBPACK FOOTER //
// ./src/app/pages/User/Takemoney/TakemoneyItem.js